"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const cache_1 = require("@almservices-cl/cache");
class Environment {
    constructor(client) {
        this.productionEnvironment = {
            name: "Production",
            endpoint: "https://api.personalbodyplan.com",
            isProduction: true,
        };
        this.localEnvironment = {
            name: "Local",
            endpoint: "https://pbp.local",
            isProduction: false,
        };
        this.environmentFromRawToAPI = ({ name, pbp_host: endpoint, is_production: isProduction, }) => ({
            name,
            endpoint: "https://" + endpoint,
            isProduction,
        });
        this.getEnvironmentsFromAPI = () => this.client
            .get("index.json", {})
            .then((environments) => [
            ...environments.map(this.environmentFromRawToAPI),
            this.productionEnvironment,
            this.localEnvironment,
        ]);
        this.getDefaultEnvironment = () => {
            return [this.productionEnvironment, this.localEnvironment];
        };
        this.getAvailableEnvironments = () => {
            const o = new cache_1.Observable();
            o.setValue(this.getDefaultEnvironment());
            this.getEnvironmentsFromAPI().then(o.setValue).catch(o.setError);
            return o;
        };
        this.client = client;
    }
}
exports.default = Environment;
//# sourceMappingURL=Environment.js.map